import { routes } from '@/shared/routes';

import { hideSpinner, showSpinner } from '@/front/spinner';

export type FetchOptions = {
  json?: boolean;
};

export const GET = async (url: string, options?: FetchOptions) => await fetch_('GET', url, options);

export const POST = async (url: string, data?: any, options?: FetchOptions) => await fetch_('POST', url, data, options);

export const PATCH = async (url: string, data?: any, options?: FetchOptions) =>
  await fetch_('PATCH', url, data, options);

export const DELETE = async (url: string, options?: FetchOptions) => await fetch_('DELETE', url, options);

const fetch_ = async (method: 'GET' | 'POST' | 'PATCH' | 'DELETE', url: string, data?: any, options?: FetchOptions) => {
  showSpinner();

  const isJson = options?.json ?? true;

  try {
    const res = await fetch(url, {
      method,
      headers: isJson
        ? {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        : undefined,
      ...(data ? { body: isJson ? JSON.stringify(data) : data } : {}),
    });

    hideSpinner();

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        window.location.href = routes.unauthorised;
      } else if (res.status === 404) {
        window.location.href = routes.notFound;
      } else if (res.status === 500) {
        console.error(res.statusText);
        window.location.href = routes.error;
      }
    }

    return res;
  } catch (error: any) {
    hideSpinner();
    throw error;
  }
};
